<script>
	export let item = undefined;
	export const getOptionLabel = undefined;
</script> 

<div class="hover:bg-gray-200 cursor-pointer border-b"> 
  <div class="p-3 truncate whitespace-pre-wrap leading-6">
    <div class="font-bold text-sm">{item.desa}</div>
    <div class="text-xs">{item.kec} {item.kab} {item.prov}</div>
  </div>
</div>
